// This file was generated by figma/utils.mjs
export const BRONTE_ICONS_NAMES = {
  ADD: 'Add',
  AFTERPAY: 'Afterpay',
  ARROWDOWN: 'ArrowDown',
  ARROWLEFT: 'ArrowLeft',
  ARROWRIGHT: 'ArrowRight',
  ARROWUP: 'ArrowUp',
  ATTACHMENT: 'Attachment',
  BANK: 'Bank',
  BANKSTATEMENT: 'BankStatement',
  BARCODE: 'Barcode',
  BASKETUPDATE: 'BasketUpdate',
  BOX: 'Box',
  BOXARROWDOWN: 'BoxArrowDown',
  BPAY: 'Bpay',
  BROWSER: 'Browser',
  BULB: 'Bulb',
  CALENDAR: 'Calendar',
  CALENDARDATE: 'CalendarDate',
  CAMERA: 'Camera',
  CAR: 'Car',
  CARD: 'Card',
  CARDUPDATE: 'CardUpdate',
  CARETDOWN: 'CaretDown',
  CARETLEFT: 'CaretLeft',
  CARETRIGHT: 'CaretRight',
  CARETUP: 'CaretUp',
  CHAT: 'Chat',
  CHATTING: 'Chatting',
  CHECK: 'Check',
  CHECKIN: 'CheckIn',
  CHECKOUT: 'CheckOut',
  CHEQUE: 'Cheque',
  CLOSE: 'Close',
  CLOSECIRCLE: 'CloseCircle',
  COINS: 'Coins',
  COPY: 'Copy',
  CURRENCYEXCHANGE: 'CurrencyExchange',
  DISCOUNT2: 'Discount2',
  DOLLAR: 'Dollar',
  DOWNLOAD: 'Download',
  DOWNLOADALT: 'DownloadAlt',
  EDIT: 'Edit',
  EMAIL: 'Email',
  EXIT: 'Exit',
  EXTERNAL: 'External',
  FILTER: 'Filter',
  GIFT: 'Gift',
  GLOBE: 'Globe',
  GRID: 'Grid',
  GUARD: 'Guard',
  HANDOUT: 'Handout',
  HEART: 'Heart',
  HEARTBEAT: 'Heartbeat',
  HISTORY: 'History',
  HOME: 'Home',
  IMAGE: 'Image',
  INFO: 'Info',
  LIGHTNING: 'Lightning',
  LINK: 'Link',
  LOAN: 'Loan',
  LOCATION: 'Location',
  LOCK: 'Lock',
  MAP: 'Map',
  MEDAL: 'Medal',
  MEDAL2: 'Medal2',
  MEDAL3: 'Medal3',
  MENU: 'Menu',
  MERCHANT: 'Merchant',
  MESSAGE: 'Message',
  METER: 'Meter',
  MOBILEBANKING: 'MobileBanking',
  MONEYTIME: 'MoneyTime',
  MONEYTRANSFER: 'MoneyTransfer',
  MORE: 'More',
  NEWBYRONMANAGELIMITS: 'NewByronManageLimits',
  NEWBYRONPHONEGENERAL: 'NewByronPhoneGeneral',
  NOCREDITCHECK: 'NoCreditCheck',
  NOFEES: 'NoFees',
  NOTIFICATION: 'Notification',
  OPENINGTIME: 'OpeningTime',
  ORDER: 'Order',
  PASSWORDHIDE: 'PasswordHide',
  PASSWORDSHOW: 'PasswordShow',
  PAYID: 'Payid',
  PHONE: 'Phone',
  PIE: 'Pie',
  PIGGY: 'Piggy',
  PRINTER: 'Printer',
  PROFILE: 'Profile',
  REFRESH: 'Refresh',
  REFUND: 'Refund',
  SEARCH: 'Search',
  SEND: 'Send',
  SETTINGS: 'Settings',
  SHARE: 'Share',
  SHARE2: 'Share2',
  SHIPPING1: 'Shipping1',
  SHIPPING2: 'Shipping2',
  SHOP: 'Shop',
  SHOPPINGCART: 'ShoppingCart',
  STAR: 'Star',
  STARHOLLOW: 'StarHollow',
  SUPPORT: 'Support',
  THUMBSUP: 'Thumbsup',
  TIME: 'Time',
  TRASH: 'Trash',
  VERIFIED: 'Verified',
  WARNING: 'Warning',
  WARNINGALT: 'WarningAlt',
  WRITE: 'Write',
} as const
